// removed by extract-text-webpack-plugin
module.exports = {"scrapFormContentWrap":"qempo_ScrapInputBlock_scrapFormContentWrap-10b4Olu","scrapFormContent":"qempo_ScrapInputBlock_scrapFormContent-5GzILDp","variant":"qempo_ScrapInputBlock_variant-1pjrcxv","inputWrap":"qempo_ScrapInputBlock_inputWrap-2jjU8oD","benefitsWrap":"qempo_ScrapInputBlock_benefitsWrap-23lNuwp","benefitsPairWrap":"qempo_ScrapInputBlock_benefitsPairWrap-1POTOVh","benefit":"qempo_ScrapInputBlock_benefit-2rGr2tX"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/store/components/ScrapInputBlock/ScrapInputBlock.scss
// module id = 1968
// module chunks = 0